"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var PaymentDisclaimer_1 = require("./paymentDisclaimer/PaymentDisclaimer");
var PaymentPage_1 = require("./PaymentPage");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var DealStatus_1 = require("../../enum/DealStatus");
var SelectPaymentAmount_1 = require("./selectPaymentAmount/SelectPaymentAmount");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var dataLayerToggleVerification_1 = require("../../../../../../common/utilities/dataLayerToggleVerification");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var cache_1 = require("../../../common/graphql/cache");
var useCallDigitalAssignmentEntryEvent_1 = require("../../../common/hooks/dataLayer/useCallDigitalAssignmentEntryEvent");
var customDatalayerInterface_1 = require("../../../../../../common/utilities/customDatalayerInterface");
var useJourneyStepsContext_1 = require("../../hooks/useJourneyStepsContext");
var ScrollInViewTypes_1 = require("../../../../common/enum/ScrollInViewTypes");
var useIsTablet_1 = require("../../../../common/react/useIsTablet");
var core_1 = require("@material-ui/core");
var TransactionErrorTypes_1 = require("../../../../../src/common/enum/TransactionErrorTypes");
var paymentType_1 = require("../../../../../src/gql/common/constants/paymentType");
var InStorePayment_1 = require("./InStorePayment");
var useSalesEnablementContext_1 = require("../../../../../../checkout_lite/src/gql/common/hooks/useSalesEnablementContext");
var PaymentContainer = function () {
    var _a, _b, _c, _d, _e;
    var isTablet = useIsTablet_1.default();
    var deal = useCheckoutContext_1.default().deal;
    var isInSalesEnablement = useSalesEnablementContext_1.default().isInSalesEnablement;
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var _f = usePlatformConfig_1.default().platformConfig, checkout = _f.checkout, paymentProvider = _f.paymentProvider;
    var checkoutLite = core_1.useTheme().checkoutLite;
    var scrollAdjustmentToPaymentMethodStep = (_b = (_a = checkoutLite) === null || _a === void 0 ? void 0 : _a.checkout4, (_b !== null && _b !== void 0 ? _b : {})).scrollAdjustmentToPaymentMethodStep;
    var journeys = ((_c = checkout) === null || _c === void 0 ? void 0 : _c.journeys) || [];
    var isPaymentProcessed = react_1.useMemo(function () { var _a, _b; return ((_a = deal) === null || _a === void 0 ? void 0 : _a.status) === DealStatus_1.DealStatus.AUTHORIZED || ((_b = deal) === null || _b === void 0 ? void 0 : _b.status) === DealStatus_1.DealStatus.FAILED; }, [deal]);
    var _g = react_1.useState(isPaymentProcessed), displayPayment = _g[0], setDisplayPayment = _g[1];
    var journeyType = cache_1.activeJourneyType();
    var isDataLayer = dataLayerToggleVerification_1.default(dimensions);
    var callDigitalAssignmentEntryEvent = useCallDigitalAssignmentEntryEvent_1.default().callDigitalAssignmentEntryEvent;
    var activeStep = useJourneyStepsContext_1.default().activeStep;
    var isStripeAndInPaymentInitOrCancelled = paymentProvider === paymentType_1.default.STRIPE &&
        (deal.status === TransactionErrorTypes_1.TransactionErrorTypes.PAYMENT_INIT || deal.status === TransactionErrorTypes_1.TransactionErrorTypes.CANCELLED);
    var showPayment = react_1.useCallback(function () {
        if (isDataLayer && journeyType === globalTypes_1.JourneyType.online_order) {
            callDigitalAssignmentEntryEvent({ deal: deal, dimensions: dimensions, stage: customDatalayerInterface_1.DataLayerFormStage.PAYMENT_METHOD });
        }
        setDisplayPayment(true);
        if (scrollAdjustmentToPaymentMethodStep && isTablet) {
            var stepElement_1 = document.querySelector("[data-test=\"checkout:step_" + activeStep + "\"]");
            setTimeout(function () {
                var _a;
                (_a = stepElement_1) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: ScrollInViewTypes_1.ScrollInViewBehaviourType.SMOOTH, block: ScrollInViewTypes_1.ScrollInViewBlockType.START });
            }, 150);
        }
    }, [displayPayment, journeyType, isDataLayer, scrollAdjustmentToPaymentMethodStep, isTablet]);
    var showPaymentAmountSelectionComponent = react_1.useMemo(function () {
        var _a, _b, _c, _d;
        var availablePayment = (_a = journeys) === null || _a === void 0 ? void 0 : _a.find(function (journey) { var _a, _b; return null != ((_a = journey) === null || _a === void 0 ? void 0 : _a.availablePaymentTypes) && ((_b = journey) === null || _b === void 0 ? void 0 : _b.journeyType) === globalTypes_1.JourneyType.reserve_online; });
        if (!availablePayment) {
            return false;
        }
        return (((_d = (_c = (_b = availablePayment) === null || _b === void 0 ? void 0 : _b.availablePaymentTypes) === null || _c === void 0 ? void 0 : _c.cash) === null || _d === void 0 ? void 0 : _d.types) || []).some(function (pt) { return pt === globalTypes_1.PaymentType.full_payment; });
    }, [journeys]);
    if (isInSalesEnablement) {
        return <InStorePayment_1.default />;
    }
    if (displayPayment || isStripeAndInPaymentInitOrCancelled) {
        return <PaymentPage_1.default deal={deal}/>;
    }
    return (<>
      {showPaymentAmountSelectionComponent && ((_e = (_d = deal) === null || _d === void 0 ? void 0 : _d.finance) === null || _e === void 0 ? void 0 : _e.type) === 'cash' && <SelectPaymentAmount_1.default />}
      <PaymentDisclaimer_1.default handleClick={showPayment}/>
    </>);
};
exports.default = PaymentContainer;
